import {
  StarIcon as OutlineStarIcon,
} from '@heroicons/react/24/outline';
import { StarIcon as SolidStarIcon } from '@heroicons/react/24/solid';
import { cn } from '../../utils/common-utils.ts';

interface IProps {
  starred: boolean;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  compact?: boolean;
}

export const QuestionLogStarButton = ({
  starred,
  onClick,
  disabled = false,
  className,
  compact = false,
}: IProps) => (
  <button
    type="button"
    aria-label={starred ? 'Unstar question' : 'Star question'}
    disabled={disabled}
    onClick={(event) => {
      event.stopPropagation();
      if (disabled) {
        return;
      }

      onClick();
    }}
    className={cn(
      'inline-flex items-center justify-center rounded-full transition-colors disabled:cursor-not-allowed disabled:opacity-60',
      compact ? 'h-8 w-8' : 'h-9 w-9',
      starred
        ? 'text-[#EDB21A] hover:bg-[#FFF5D6]'
        : 'text-gray hover:bg-light-gray hover:text-dark-blue',
      className,
    )}
  >
    {starred ? (
      <SolidStarIcon className={compact ? 'h-5 w-5' : 'h-6 w-6'} />
    ) : (
      <OutlineStarIcon className={compact ? 'h-5 w-5' : 'h-6 w-6'} />
    )}
  </button>
);
